import { render } from "./SandboxUserAccess.vue?vue&type=template&id=ac0ab936"
import script from "./SandboxUserAccess.vue?vue&type=script&lang=js"
export * from "./SandboxUserAccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__